import { apiClient } from '../../../platform/api/apiClient';

export const gameService = {
    getGameDays() {
        return apiClient.get('GameDay');
    },

    getGameDay(gameDayId) {
        return apiClient.get(`GameDay/${gameDayId}`);
    },

    getEventGameDay(eventId) {
        return apiClient.get(`GameDay/event/${eventId}`);
    },

    createGameDay(payload) {
        return apiClient.post('GameDay', { json: payload });
    },

    updateGameDay(gameDayId, payload) {
        return apiClient.put(`GameDay/${gameDayId}`, { json: payload });
    },

    deleteGameDay(gameDayId) {
        return apiClient.del(`GameDay/${gameDayId}`);
    },

    getSpecies() {
        return apiClient.get('GameSpecies');
    },

    addDrive(gameDayId, payload) {
        return apiClient.post(`GameDay/${gameDayId}/drives`, { json: payload });
    },

    updateDrive(gameDayId, driveId, payload) {
        return apiClient.put(`GameDay/${gameDayId}/drives/${driveId}`, { json: payload });
    },

    deleteDrive(gameDayId, driveId) {
        return apiClient.del(`GameDay/${gameDayId}/drives/${driveId}`);
    },

    addShooter(gameDayId, payload) {
        return apiClient.post(`GameDay/${gameDayId}/shooters`, { json: payload });
    },

    updateShooter(gameDayId, shooterId, payload) {
        return apiClient.put(`GameDay/${gameDayId}/shooters/${shooterId}`, { json: payload });
    },

    deleteShooter(gameDayId, shooterId) {
        return apiClient.del(`GameDay/${gameDayId}/shooters/${shooterId}`);
    },

    addGun(gameDayId, driveId, payload) {
        return apiClient.post(`GameDay/${gameDayId}/drives/${driveId}/guns`, { json: payload });
    },

    updateGun(gameDayId, driveId, gunId, payload) {
        return apiClient.put(`GameDay/${gameDayId}/drives/${driveId}/guns/${gunId}`, { json: payload });
    },

    deleteGun(gameDayId, driveId, gunId) {
        return apiClient.del(`GameDay/${gameDayId}/drives/${driveId}/guns/${gunId}`);
    },

    addBagItem(gameDayId, payload) {
        return apiClient.post(`GameDay/${gameDayId}/bag`, { json: payload });
    },

    updateBagItem(gameDayId, bagItemId, payload) {
        return apiClient.put(`GameDay/${gameDayId}/bag/${bagItemId}`, { json: payload });
    },

    deleteBagItem(gameDayId, bagItemId) {
        return apiClient.del(`GameDay/${gameDayId}/bag/${bagItemId}`);
    }
};
